import { useEffect, useState } from 'react';
import { useFragment, graphql } from 'react-relay';
import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

import { useEuEligible } from './useEuEligible';

import type { useExposedReturnsClientVariant_viewer$key } from './__generated__/useExposedReturnsClientVariant_viewer.graphql';

const viewerFragment = graphql`
    fragment useExposedReturnsClientVariant_viewer on Viewer {
        ...useEuEligible_viewer @arguments(userCountryCode: $userCountryCode)
    }
`;

export const useExposedReturnsClientVariant = ({
    viewer: viewerRef,
}: {
    viewer?: useExposedReturnsClientVariant_viewer$key | null;
}): boolean | null => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const isEuEligible = useEuEligible({ viewer });

    const [isExposedReturnsClientVariant, setIsExposedReturnsClientVariant] =
        useState<boolean>(false);

    useEffect(() => {
        if (isEuEligible && getAbTestV2('ReturnsonPDP')?.variant === 'variant') {
            setIsExposedReturnsClientVariant(true);
        }
    }, [isEuEligible]);

    return isExposedReturnsClientVariant;
};
